<script setup lang="ts">
import type { CmsBlockTextTwoColumn } from "@shopware-pwa/composables-next";
import { useCmsBlock } from "#imports";

const props = defineProps<{
  content: CmsBlockTextTwoColumn;
}>();

const { getSlotContent } = useCmsBlock(props.content);

const leftContent = getSlotContent("left");
const rightContent = getSlotContent("right");
</script>

<template>
  <div class="fragen px-4 !m-0">
    <div class="container mx-auto py-12 sm:py-24">
      <div class="wrap flex justify-between flex-wrap lg:flex-nowrap">
        <div
          class="left w-full md:w-full lg:w-[480px] mb-0 md:mb-8 lg:mb-0 pr-0 lg:pr-5 xl:pr-0"
        >
          <CmsGenericElement :content="leftContent" />
        </div>

        <div class="right w-full md:w-full lg:w-[590px] py-8 px-6 md:py-12 md:px-8 rounded-lg shadow-xl">
          <CmsGenericElement :content="rightContent" />
        </div>
      </div>
    </div>
  </div>
</template>
